import React from "react";
import StackTokenv3Section from "../sections/StackTokenv3Section/Content";
const StackTokenv3Page = () => {
  return <StackTokenv3Section />;
};

export default StackTokenv3Page;
